import { jsx } from "react/jsx-runtime";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { validateTidalLicense } from "../../base/index.js";
function Equalizer(props) {
  return /* @__PURE__ */ jsx(
    EqualizerIcon,
    {
      "data-testid": "Equalizer",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Equalizer",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Equalizer.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Equalizer"
};
validateTidalLicense();
export {
  Equalizer
};
//# sourceMappingURL=Equalizer.js.map
